export function toLocaleDecimal(value: number, maximumFractionDigits = 1) {
  return value.toLocaleString(undefined, {
    maximumFractionDigits,
    style: "decimal",
  });
}
